import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from './components/component/Header';
import ScrollToTop from './components/component/ScrollToTop';
import LoginPage from './components/LoginPage';
import OrderListPage from './components/OrderListPage';
import PickingListPage from './components/PickingListPage';
import './index.css';

function App() {
  return (
    <div className='root'>
      <Header />
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/orders" element={<OrderListPage />} />
          <Route path="/orders/:order_uuid" element={<PickingListPage />} />
        </Routes>
      </ScrollToTop>
    </div>
  );
}

export default App;
